export class OrgCategory {
  categoryId: number;
  categoryName: string;

  constructor(json?: any) {
    this.categoryId = json.categoryId;
    this.categoryName = json.categoryName;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/OrgCategory.ts